import { render, staticRenderFns } from "./aeronave.vue?vue&type=template&id=4f2e3c22&scoped=true"
import script from "./aeronave.vue?vue&type=script&lang=js"
export * from "./aeronave.vue?vue&type=script&lang=js"
import style0 from "./aeronave.vue?vue&type=style&index=0&id=4f2e3c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e3c22",
  null
  
)

export default component.exports